/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { co_getplato_grid_api_domain_Address } from './co_getplato_grid_api_domain_Address';
import type { co_getplato_grid_api_domain_SalesRep } from './co_getplato_grid_api_domain_SalesRep';
import type { co_getplato_grid_api_sales_SalesOrderItemResponseDTO } from './co_getplato_grid_api_sales_SalesOrderItemResponseDTO';
export type co_getplato_grid_api_sales_SalesOrderResponseDTO = {
    sales_order_id: string;
    customer_id: string;
    clerk_id?: string;
    clerk_name?: string;
    contact_id?: string;
    contact_name?: string;
    storage_id?: string;
    shipping_type_id?: string;
    display_identifier?: string;
    due_date?: string;
    invoice_date?: string;
    order_created_at_date?: string;
    desired_delivery_date?: string;
    released_date?: string;
    document_type?: string;
    po_number?: string;
    text?: string;
    is_created_in_plato: boolean;
    line_items_count: number;
    total_margin?: number;
    total_amount_net?: number;
    sales_order_items?: Array<co_getplato_grid_api_sales_SalesOrderItemResponseDTO>;
    delivery_address?: co_getplato_grid_api_domain_Address;
    billing_address?: co_getplato_grid_api_domain_Address;
    sales_reps?: Array<co_getplato_grid_api_domain_SalesRep>;
    status?: co_getplato_grid_api_sales_SalesOrderResponseDTO.status;
    type?: co_getplato_grid_api_sales_SalesOrderResponseDTO.type;
    createdInPlato?: boolean;
};
export namespace co_getplato_grid_api_sales_SalesOrderResponseDTO {
    export enum status {
        OPEN = 'OPEN',
        PARTIALLY_BILLED = 'PARTIALLY_BILLED',
        BILLED = 'BILLED',
        OPEN_IN_PICKING = 'OPEN_IN_PICKING',
        PROCESSED_INTERNALLY = 'PROCESSED_INTERNALLY',
        CANCELLED = 'CANCELLED',
        PARTIALLY_RECEIVED = 'PARTIALLY_RECEIVED',
        RECEIVED = 'RECEIVED',
        LOST = 'LOST',
        REVISED = 'REVISED',
        COMPLETED = 'COMPLETED',
        UNKNOWN = 'UNKNOWN',
        RELEASED_FOR_DELIVERY = 'RELEASED_FOR_DELIVERY',
        RETURNED = 'RETURNED',
        SHIPPED = 'SHIPPED',
        PARTIALLY_PICKED = 'PARTIALLY_PICKED',
        PICKED = 'PICKED',
        PARTIALLY_SHIPPED = 'PARTIALLY_SHIPPED',
        PENDING = 'PENDING',
        OTHER = 'OTHER',
    }
    export enum type {
        ORDER = 'ORDER',
        QUOTE = 'QUOTE',
        CREDIT_NOTE = 'CREDIT_NOTE',
    }
}

